import React from 'react';
import { useCountUp } from './useCountUp';

const STATS = [
  { target: 10000, suffix: '+', label: 'UK Agreements Analysed' },
  { target: 50, suffix: '+', label: 'Current Legislation Covered' },
  { target: 99, suffix: '.8%', label: 'Compliance Accuracy' },
  { target: 4200, suffix: '+', label: 'Agreements Fixed' },
];

function StatItem({ target, suffix, label }: { target: number; suffix: string; label: string }) {
  const { count, ref } = useCountUp(target, 2000);
  return (
    <div ref={ref} className="text-center">
      <div className="text-3xl sm:text-4xl font-bold text-white mb-1">
        {count.toLocaleString()}{suffix}
      </div>
      <p className="text-sm text-gray-400">{label}</p>
    </div>
  );
}

export function StatsBar() {
  return (
    <section className="py-16 sm:py-20 bg-gray-900 bg-dot-pattern relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-transparent to-gray-900" />
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-10">
          {STATS.map((s) => (
            <StatItem key={s.label} {...s} />
          ))}
        </div>
        <p className="text-center text-sm text-gray-500 max-w-2xl mx-auto leading-relaxed">
          Our AI is trained on over 10,000 UK agreements and the latest housing legislation.
          We continuously update our training data to stay ahead of regulatory changes.
        </p>
      </div>
    </section>
  );
}
